var _defs, _g, _path, _path2, _path3, _g2, _path4, _g3, _g4, _g5, _path5, _path6, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Page(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 570,
    height: 466.011,
    viewBox: "0 0 570 466.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.98,
    x2: 0.5,
    y2: 0.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(-26.516 -57.452)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(29.78 115.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M560.936,393.058H110.3c-4.468,0-9.244.5-13.7,0-31.542-3.5-53.1-38.093-62.052-65.553a110.4,110.4,0,0,1-4.759-21.83C27.225,283.024,31.936,259.5,47.634,242.2,61.4,227.039,84.355,224.99,96.778,208.759c9.164-11.924,9.762-28.218,14.989-41.884,3.42-8.938,8.97-17.344,17.021-22.539,6.809-4.388,15-6.212,23.1-6.776a85.133,85.133,0,0,1,37.722,5.986,104.025,104.025,0,0,0,38.609,7.55c15.537.21,30.235-2.339,45.175-6.212,14.617-3.774,30.105-5.146,43.545-12.5,18.989-10.375,32.623-24.588,55.017-27.67,23.943-3.308,50.612,5,66.923,23.233,11,12.311,15.667,28.3,12.2,44.545-2.147,9.988-7.181,21.039.6,29.946,5.13,5.9,13.471,7.808,21.248,8.389,20.99,1.6,39.367,5.825,54.533,21.669,14.973,15.666,16.231,30.832,17.167,51.386a89.989,89.989,0,0,1-1.984,21.8c-.356,1.807-.759,3.615-1.178,5.422-.258,1.1-.517,2.178-.79,3.275-2.243,8.954-6.18,18.312-6.245,27.622-.112,16.681,14.973,25.169,21.781,38.656C556.79,381.8,560.872,393.058,560.936,393.058Z",
    transform: "translate(-29.131 -104)",
    fill: "#d9dffb"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M542.641,305.676H29.79C27.225,283.024,31.936,259.5,47.634,242.2,61.4,227.039,84.355,224.99,96.778,208.759c9.164-11.924,9.762-28.218,14.989-41.884,3.42-8.938,8.97-17.344,17.021-22.539,6.809-4.388,15-6.212,23.1-6.776a85.133,85.133,0,0,1,37.722,5.986,104.025,104.025,0,0,0,38.609,7.55c15.537.21,30.235-2.339,45.175-6.212,14.617-3.774,30.105-5.146,43.545-12.5,18.989-10.375,32.623-24.588,55.017-27.67,23.943-3.308,50.612,5,66.923,23.233,11,12.311,15.667,28.3,12.2,44.545-2.147,9.988-7.181,21.039.6,29.946,5.13,5.9,13.471,7.808,21.248,8.389,20.99,1.6,39.367,5.825,54.533,21.669,14.973,15.666,16.231,30.832,17.167,51.386A89.989,89.989,0,0,1,542.641,305.676Z",
    transform: "translate(0.649 11.484)",
    opacity: 0.2,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M199.28,301.828V198.441H154.589l-58.583,83.8L80.679,304.167v32.285h78.588v30.412H199.28V336.451h19.167V301.828Zm-37.2,0H122.789l12.956-19.587,26.331-39.818Z",
    transform: "translate(13.44 34.919)",
    fill: "#1b2c56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M214.178,328.719v11.424H112.516a9.6,9.6,0,0,1,7.49-7.777c4.9-.935,8.441,2.747,8.675,2.981.216-.754,2.354-7.7,9.286-10.165a14.728,14.728,0,0,1,9.573,0,6.841,6.841,0,0,1,8.389-8.982,13.526,13.526,0,0,1,24.535,4.185,6.8,6.8,0,0,1,12.286,1.8,12.545,12.545,0,0,1,21.428,6.538Z",
    transform: "translate(21.341 62.6)",
    fill: "#99a6d6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M266.185,158.292c-48.66,0-65.73,36.495-65.73,86.543,0,17.876,2.146,33.993,7.066,47.368,8.97,24.428,27.218,39.657,58.664,39.657,31.428,0,49.692-15.23,58.663-39.657,4.92-13.375,7.067-29.492,7.067-47.368C331.915,194.787,314.829,158.292,266.185,158.292Zm0,136.138a25.748,25.748,0,0,1-11.15-2.227c-13.439-6.292-15.295-25.281-15.295-47.368,0-26.186,2.807-49.112,26.445-49.112,23.62,0,26.427,22.926,26.427,49.112,0,22.087-1.856,41.06-15.279,47.368A25.793,25.793,0,0,1,266.185,294.43Z",
    transform: "translate(43.162 24.956)",
    fill: "#1b2c56"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(394.449 377.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M406.716,329.573v9.6H321.3a8.07,8.07,0,0,1,6.293-6.534c4.12-.785,7.093,2.309,7.289,2.505.181-.634,1.977-6.474,7.8-8.541a12.375,12.375,0,0,1,8.043,0,5.748,5.748,0,0,1,7.048-7.546,11.364,11.364,0,0,1,20.614,3.516,5.714,5.714,0,0,1,10.322,1.509,10.541,10.541,0,0,1,18,5.494Z",
    transform: "translate(-321.299 -313.839)",
    fill: "#99a6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M388.19,337.6h31.591a6.8,6.8,0,0,0-11.021-6.5,3.531,3.531,0,0,0-5.785-3.856,9.227,9.227,0,0,0-6.336-6.795c-4.1-1.1-8.806,1.165-10.835,5.6Q387,331.824,388.19,337.6Z",
    transform: "translate(-305.292 -312.268)",
    fill: "#537ec5"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M435.638,301.828V198.441H390.964l-58.6,83.8-15.327,21.926v32.285h78.606v30.412h40V336.451h19.183V301.828Zm-37.189,0h-39.3L372.1,282.24l26.347-39.818Z",
    transform: "translate(72.092 34.919)",
    fill: "#1b2c56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M151.542,198.441h44.691v83.8H92.959Z",
    transform: "translate(16.488 34.919)",
    opacity: 0.2,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M331.915,244.835c0,17.876-2.147,33.993-7.067,47.368H207.521c-4.92-13.375-7.066-29.492-7.066-47.368,0-50.048,17.07-86.543,65.73-86.543C314.829,158.292,331.915,194.787,331.915,244.835Z",
    transform: "translate(43.162 24.956)",
    opacity: 0.2,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M432.591,198.441v83.8H329.318l58.6-83.8Z",
    transform: "translate(75.139 34.919)",
    opacity: 0.2,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(471.515 384.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M444.886,330.832v6.948H383.044a5.843,5.843,0,0,1,4.556-4.73,6.165,6.165,0,0,1,5.277,1.814,9.616,9.616,0,0,1,5.649-6.185,8.97,8.97,0,0,1,5.824,0,4.162,4.162,0,0,1,5.1-5.463,8.228,8.228,0,0,1,14.925,2.546,4.138,4.138,0,0,1,7.474,1.092,7.631,7.631,0,0,1,13.034,3.978Z",
    transform: "translate(-383.044 -319.441)",
    fill: "#99a6d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(58.291 5.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M431.475,336.643h22.871a4.921,4.921,0,0,0-7.979-4.708,2.557,2.557,0,0,0-4.189-2.792,6.681,6.681,0,0,0-4.587-4.919,6.9,6.9,0,0,0-7.845,4.055Q430.609,332.461,431.475,336.643Z",
    transform: "translate(-429.746 -324.024)",
    fill: "#bdc9f4"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(307.779 356.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 3.226,
    height: 44.815,
    fill: "#010038"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(243.354 374.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M297.447,329.7v10.924h-97.2a9.182,9.182,0,0,1,7.161-7.437c4.689-.894,8.072,2.627,8.3,2.851.206-.721,2.25-7.368,8.879-9.721a14.094,14.094,0,0,1,9.154,0,6.54,6.54,0,0,1,8.019-8.587,12.933,12.933,0,0,1,23.46,4,6.5,6.5,0,0,1,11.746,1.717,11.994,11.994,0,0,1,20.488,6.251Z",
    transform: "translate(-200.244 -311.792)",
    fill: "#99a6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M276.366,338.833h35.949a7.733,7.733,0,0,0-12.541-7.4,4.02,4.02,0,0,0-6.584-4.39,10.5,10.5,0,0,0-7.209-7.732c-4.668-1.253-10.021,1.327-12.33,6.374Q275.007,332.258,276.366,338.833Z",
    transform: "translate(-182.029 -310.004)",
    fill: "#bdc9f4"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M38.669,336.9c14.084,0,17.45,19.241,22.333,28.983,7.016,14,19.65,25.108,35.8,26.187,10.422.7,20.73-2.727,31.176-2.62,52.431.538,77.184,65.574,129.566,64.885,32.211-.423,60.007-19.16,87.59-33.958,14.17-7.6,28.935-14.552,44.807-17.691,20.091-3.974,40.1-.426,60.133,2.136,4.662.6,9.331,1.15,14.017,1.526,40.915,3.288,102.9-16.166,107.215-64.627q.124-1.386.157-2.777.034-1.329-.025-2.66Z",
    transform: "translate(3.016 69.124)",
    fill: "#1b2c56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M594.1,334.09H28.935a2.42,2.42,0,0,0,0,4.84H594.1a2.42,2.42,0,1,0,0-4.84Z",
    transform: "translate(0 68.58)",
    fill: "#1b2c56"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(82.42 324.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M71.306,293.216c7.056.422,9.451,7.42,10.029,9.6l7.813,7.815V285.547c-5.622-5.59-1.212-13.976-1.212-13.976,7.134,5.079,3.335,11.864,2.012,13.815v10.149l6.955-6.956c.62-7.886,9.824-9.981,9.824-9.981.768,8.728-6.867,10.239-9.206,10.5L90.009,296.6l-.061-.061V335.51h-.8V311.635l-.061.061-8.215-8.217C71.186,303.552,71.306,293.216,71.306,293.216Z",
    transform: "translate(-71.306 -271.572)",
    fill: "#ff502f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    d: "M3.272,0h9.968a3.272,3.272,0,0,1,3.272,3.272V16.688a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.272A3.272,3.272,0,0,1,3.272,0Z",
    transform: "translate(26.764 78.431) rotate(180)",
    fill: "#1b2c56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(17.333 30.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M108.11,314.3l-4.141,3.757V314.04c3.14-1.561,10-7.036,6.415-18.038,0,0-12.47,4.777-8.013,18.044v5.8L98.929,316c-.454-2.982-3.281-10.468-13.736-10.234,0,0,.838,11.454,12.69,11.462l4.488,5.006v7.677h1.6v-9.7l5.165-4.686c10.519.716,12.077-9.431,12.077-9.431C111.847,305.146,108.751,311.63,108.11,314.3Z",
    transform: "translate(-85.193 -296.002)",
    fill: "#49beb7"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M109.56,338.028H94.115l-3.2-17.842h21.837Z",
    transform: "translate(-83.772 -290.001)",
    fill: "#1b2c56"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(566.104 325.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(10.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M473.088,284.676a71.491,71.491,0,0,1-1.787-11.518l-.026-.658-.457.473a8.051,8.051,0,0,0-2.051,5.195c0,.829.054,1.563.106,2.274a10.016,10.016,0,0,1-.645,5.356c-1.269,2.894-2.107,5.421-.423,9.375l.493,1.146c1.277,2.952,1.8,4.173,1.321,6.538a8.035,8.035,0,0,0,4.487,8.177c-.122,5.367-.277,9.833-.281,9.927l.563.021c.008-.2.711-20.433.292-26.71A71.278,71.278,0,0,0,473.088,284.676Z",
    transform: "translate(-466.861 -272.5)",
    fill: "#ff502f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(0 13.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M459.718,283.582l-.29-.227-.143.339a6.04,6.04,0,0,0,.7,5.825,7.642,7.642,0,0,1,1.258,4,11.2,11.2,0,0,0,1.94,5.707,13.249,13.249,0,0,0,3.425,3.088c1.286.875,2.214,1.508,2.434,3.082.04.282.072.548.1.8.315,2.49.489,3.872,4.115,5.1,1.051,4.089,1.539,6.94,1.553,7.026l.555-.094C475.325,317.974,470.938,292.372,459.718,283.582Z",
    transform: "translate(-458.828 -283.355)",
    fill: "#ff502f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(18.052 20.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M481,289.312l-.085-.4-.342.22c-8.631,5.549-7.229,26.607-7.166,27.5l.281-.021h0l.281-.02c0-.064-.134-2.007-.094-4.844.273-.417,1.326-2.023,2.121-3.266a2.889,2.889,0,0,0,.242-2.376,5.912,5.912,0,0,1-.06-2.6,4.742,4.742,0,0,1,1.2-2.423,7.614,7.614,0,0,0,1.309-2.069,6.792,6.792,0,0,0,.448-2.921,3.687,3.687,0,0,1,.741-2.785A4.857,4.857,0,0,0,481,289.312Z",
    transform: "translate(-473.291 -288.914)",
    fill: "#ff502f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M479.358,339.923h-9.982l-2.764-29.285h15.511Z",
    transform: "translate(-456.896 -263.036)",
    fill: "#1b2c56"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(57.242 57.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M368.515,89.9a11.2,11.2,0,0,0-1.4-4.792l1.39-.775a12.886,12.886,0,0,0-2.685-3.346l-1.058,1.191a11.2,11.2,0,0,0-4.375-2.406l.433-1.524-.02-.005a12.769,12.769,0,0,0-3.495-.487c-.252,0-.5.006-.751.021l.094,1.589a11.22,11.22,0,0,0-4.793,1.4l-.774-1.39a12.835,12.835,0,0,0-3.349,2.682l1.191,1.058a11.187,11.187,0,0,0-2.41,4.374l-1.523-.434-.009.029a12.784,12.784,0,0,0-.487,3.5q0,.371.021.741l1.589-.094a11.221,11.221,0,0,0,1.394,4.794l-1.39.773a12.857,12.857,0,0,0,2.679,3.351l1.061-1.189a11.19,11.19,0,0,0,4.371,2.413l-.437,1.524.04.011a12.825,12.825,0,0,0,3.5.487q.388,0,.771-.024l-.1-1.588a11.225,11.225,0,0,0,4.79-1.407l.776,1.389a12.837,12.837,0,0,0,3.344-2.687l-1.191-1.057a11.2,11.2,0,0,0,2.4-4.377l1.524.432,0-.01a12.819,12.819,0,0,0,.487-3.495c0-.255-.008-.509-.022-.761Zm-13.989,10.509h0l.079-.277Zm9.317-7.988a6.782,6.782,0,1,1,.258-1.852A6.793,6.793,0,0,1,363.843,92.419Z",
    transform: "translate(21.663 -52.751)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M338.515,173.9a11.2,11.2,0,0,0-1.4-4.792l1.39-.775a12.884,12.884,0,0,0-2.685-3.346l-1.058,1.191a11.2,11.2,0,0,0-4.375-2.406l.433-1.524-.02,0a12.767,12.767,0,0,0-3.495-.487c-.252,0-.5.006-.751.021l.094,1.589a11.22,11.22,0,0,0-4.793,1.4l-.774-1.39a12.834,12.834,0,0,0-3.349,2.682l1.191,1.058a11.187,11.187,0,0,0-2.41,4.374l-1.523-.434-.009.029a12.785,12.785,0,0,0-.487,3.5q0,.371.021.741l1.589-.094a11.22,11.22,0,0,0,1.394,4.794l-1.39.773a12.859,12.859,0,0,0,2.679,3.351l1.061-1.189a11.19,11.19,0,0,0,4.371,2.413l-.437,1.524.04.011a12.826,12.826,0,0,0,3.5.487q.388,0,.771-.024l-.1-1.588a11.226,11.226,0,0,0,4.79-1.407l.776,1.389a12.837,12.837,0,0,0,3.344-2.687l-1.191-1.057a11.2,11.2,0,0,0,2.4-4.377l1.524.432,0-.01a12.819,12.819,0,0,0,.487-3.495c0-.255-.007-.509-.022-.761Zm-13.989,10.509h0l.079-.277Zm9.317-7.988a6.782,6.782,0,1,1,.258-1.852A6.793,6.793,0,0,1,333.843,176.419Z",
    transform: "translate(14.219 -31.907)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M120.262,107.332a6.662,6.662,0,0,0-.836-2.855l.829-.462a7.65,7.65,0,0,0-1.6-1.995l-.63.71a6.66,6.66,0,0,0-2.607-1.434l.258-.909-.011,0a7.612,7.612,0,0,0-2.083-.291c-.15,0-.3,0-.448.014l.056.946a6.687,6.687,0,0,0-2.856.834l-.461-.829a7.646,7.646,0,0,0-2,1.6l.709.63a6.673,6.673,0,0,0-1.435,2.606l-.909-.26,0,.019a7.643,7.643,0,0,0-.29,2.082c0,.149,0,.3.012.442l.947-.055a6.672,6.672,0,0,0,.831,2.857l-.83.461a7.662,7.662,0,0,0,1.6,2l.633-.708a6.662,6.662,0,0,0,2.6,1.437l-.261.909.024.006a7.661,7.661,0,0,0,2.083.291c.154,0,.307,0,.461-.014l-.057-.947a6.665,6.665,0,0,0,2.855-.839l.462.829a7.649,7.649,0,0,0,1.993-1.6l-.71-.63a6.667,6.667,0,0,0,1.432-2.609l.909.258v-.006a7.609,7.609,0,0,0,.29-2.082c0-.152,0-.3-.012-.454Zm-8.336,6.262h0l.047-.165Zm5.553-4.759a4.043,4.043,0,1,1,.154-1.1A4.049,4.049,0,0,1,117.479,108.835Z",
    transform: "translate(-37.531 -47.207)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.322
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M75.157,180.381a11.214,11.214,0,0,0-1.4-4.792l1.39-.775a12.885,12.885,0,0,0-2.685-3.346L71.4,172.659a11.2,11.2,0,0,0-4.375-2.406l.433-1.524-.02-.005a12.817,12.817,0,0,0-3.495-.487q-.378,0-.751.021l.094,1.589a11.216,11.216,0,0,0-4.793,1.4l-.774-1.39a12.86,12.86,0,0,0-3.349,2.682l1.189,1.058a11.2,11.2,0,0,0-2.409,4.373l-1.524-.434-.007.03a12.818,12.818,0,0,0-.488,3.495c0,.247.007.5.022.741l1.589-.094a11.208,11.208,0,0,0,1.394,4.8l-1.39.771a12.812,12.812,0,0,0,2.679,3.351l1.061-1.189a11.175,11.175,0,0,0,4.371,2.413l-.437,1.524.04.011a12.826,12.826,0,0,0,3.5.487c.257,0,.515-.008.771-.024l-.1-1.588a11.231,11.231,0,0,0,4.79-1.407l.776,1.389a12.836,12.836,0,0,0,3.344-2.687L72.352,188.5a11.2,11.2,0,0,0,2.4-4.377l1.523.432,0-.01a12.816,12.816,0,0,0,.487-3.495c0-.255-.007-.509-.022-.761ZM61.168,190.891h0l.077-.277Zm9.317-7.988a6.782,6.782,0,1,1,.258-1.852A6.793,6.793,0,0,1,70.486,182.9Z",
    transform: "translate(-51.133 -30.298)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M296.644,88.572a5.747,5.747,0,0,0-.721-2.463l.715-.4a6.606,6.606,0,0,0-1.38-1.719l-.544.612a5.732,5.732,0,0,0-2.248-1.237l.222-.783-.01,0a6.618,6.618,0,0,0-1.8-.25c-.13,0-.258,0-.387.011l.049.816a5.755,5.755,0,0,0-2.463.719l-.4-.714a6.582,6.582,0,0,0-1.721,1.378l.612.544a5.75,5.75,0,0,0-1.238,2.248l-.783-.223-.005.015a6.572,6.572,0,0,0-.251,1.8c0,.127,0,.255.011.381l.818-.047a5.752,5.752,0,0,0,.716,2.464l-.715.4a6.59,6.59,0,0,0,1.377,1.722l.545-.61a5.748,5.748,0,0,0,2.247,1.239l-.225.784.021,0a6.571,6.571,0,0,0,1.8.251c.132,0,.265,0,.4-.012l-.05-.816a5.755,5.755,0,0,0,2.463-.723l.4.714a6.6,6.6,0,0,0,1.72-1.382l-.613-.543a5.738,5.738,0,0,0,1.234-2.25l.784.223V90.71a6.52,6.52,0,0,0,.25-1.8c0-.131,0-.261-.011-.391Zm-7.191,5.4h0l.041-.142Zm4.789-4.105a3.491,3.491,0,0,1-3.356,2.541,3.452,3.452,0,0,1-.952-.134,3.5,3.5,0,1,1,4.309-2.408Z",
    transform: "translate(6.726 -51.616)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M171.331,99.773a5.776,5.776,0,0,0-.721-2.463l.714-.4a6.586,6.586,0,0,0-1.379-1.72l-.544.612a5.746,5.746,0,0,0-2.248-1.236l.222-.784-.01,0a6.572,6.572,0,0,0-1.8-.251c-.13,0-.258,0-.387.012l.049.816a5.755,5.755,0,0,0-2.464.719l-.4-.715a6.633,6.633,0,0,0-1.721,1.378l.612.545a5.738,5.738,0,0,0-1.238,2.247l-.784-.223,0,.016a6.571,6.571,0,0,0-.251,1.8c0,.127,0,.255.011.381l.816-.047a5.759,5.759,0,0,0,.718,2.464l-.715.4a6.608,6.608,0,0,0,1.377,1.722l.545-.612a5.766,5.766,0,0,0,2.247,1.241l-.225.783.021.006a6.57,6.57,0,0,0,1.8.25q.2,0,.4-.011l-.05-.816a5.773,5.773,0,0,0,2.463-.724l.4.714a6.585,6.585,0,0,0,1.719-1.38l-.612-.544a5.733,5.733,0,0,0,1.234-2.249l.784.222v0a6.619,6.619,0,0,0,.25-1.8c0-.131,0-.262-.011-.392Zm-7.191,5.4h0l.04-.142Zm4.789-4.105a3.491,3.491,0,0,1-6.85-.949,3.453,3.453,0,0,1,.134-.952,3.49,3.49,0,1,1,6.716,1.9Z",
    transform: "translate(-24.37 -48.836)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M188.716,170.914a5.775,5.775,0,0,0-.721-2.464l.714-.4a6.628,6.628,0,0,0-1.379-1.72l-.544.613a5.747,5.747,0,0,0-2.249-1.237l.223-.784-.01,0a6.618,6.618,0,0,0-1.8-.25c-.13,0-.258,0-.387.011l.049.816a5.756,5.756,0,0,0-2.464.719l-.4-.715a6.593,6.593,0,0,0-1.721,1.379l.612.544a5.735,5.735,0,0,0-1.238,2.248l-.784-.223,0,.015a6.571,6.571,0,0,0-.251,1.8c0,.127,0,.255.011.381l.816-.047a5.754,5.754,0,0,0,.718,2.464l-.715.4a6.589,6.589,0,0,0,1.377,1.722l.545-.612a5.726,5.726,0,0,0,2.247,1.241l-.225.783.02.006a6.588,6.588,0,0,0,1.8.251c.132,0,.265,0,.4-.012l-.05-.816a5.784,5.784,0,0,0,2.461-.723l.4.714a6.636,6.636,0,0,0,1.719-1.382l-.613-.543a5.756,5.756,0,0,0,1.236-2.25l.783.223v-.006a6.571,6.571,0,0,0,.251-1.8c0-.131,0-.261-.011-.392Zm-7.191,5.4h0l.04-.142Zm4.789-4.105a3.488,3.488,0,1,1,.132-.952A3.492,3.492,0,0,1,186.314,172.21Z",
    transform: "translate(-20.056 -31.183)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M399.44,161.581a4.749,4.749,0,0,0-.593-2.026l.587-.327a5.386,5.386,0,0,0-1.135-1.414l-.447.5A4.723,4.723,0,0,0,396,157.3l.183-.644-.009,0a5.445,5.445,0,0,0-1.477-.206c-.106,0-.212,0-.318.01l.04.672a4.752,4.752,0,0,0-2.026.59l-.327-.587a5.424,5.424,0,0,0-1.415,1.133l.5.447a4.725,4.725,0,0,0-1.017,1.849l-.644-.183,0,.012a5.4,5.4,0,0,0-.206,1.477c0,.1,0,.21.009.313l.671-.039a4.745,4.745,0,0,0,.589,2.026l-.588.327a5.435,5.435,0,0,0,1.133,1.417l.448-.5a4.716,4.716,0,0,0,1.847,1.02l-.185.644.017,0a5.445,5.445,0,0,0,1.477.206c.11,0,.218,0,.327-.01l-.041-.671a4.731,4.731,0,0,0,2.025-.6l.328.588a5.405,5.405,0,0,0,1.413-1.136l-.5-.447a4.726,4.726,0,0,0,1.015-1.85l.644.182v0a5.4,5.4,0,0,0,.206-1.478c0-.107,0-.215-.009-.322Zm-5.912,4.441h0l.032-.117Zm3.938-3.376a2.875,2.875,0,0,1-2.761,2.091,2.938,2.938,0,0,1-.783-.11,2.871,2.871,0,0,1,.78-5.633,2.841,2.841,0,0,1,.783.11,2.868,2.868,0,0,1,1.981,3.542Z",
    transform: "translate(32.779 -33.224)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M477.106,196.914a4.737,4.737,0,0,0-.593-2.026l.588-.327a5.429,5.429,0,0,0-1.135-1.414l-.448.5a4.727,4.727,0,0,0-1.848-1.017l.183-.644-.009,0a5.444,5.444,0,0,0-1.477-.206c-.107,0-.212,0-.318.01l.04.672a4.731,4.731,0,0,0-2.026.592l-.327-.588a5.427,5.427,0,0,0-1.415,1.133l.5.448a4.729,4.729,0,0,0-1.018,1.849l-.644-.185,0,.012a5.444,5.444,0,0,0-.206,1.478c0,.1,0,.21.01.313l.671-.04a4.739,4.739,0,0,0,.589,2.027l-.588.326a5.429,5.429,0,0,0,1.132,1.417l.448-.5a4.73,4.73,0,0,0,1.849,1.02l-.185.644.016.005a5.4,5.4,0,0,0,1.478.206c.109,0,.217,0,.326-.01l-.04-.672a4.745,4.745,0,0,0,2.025-.594l.327.587a5.411,5.411,0,0,0,1.414-1.136l-.5-.447a4.7,4.7,0,0,0,1.016-1.85l.644.184v-.005a5.4,5.4,0,0,0,.206-1.477c0-.109,0-.216-.01-.322Zm-5.912,4.442h0l.034-.117Zm3.938-3.376a2.871,2.871,0,0,1-2.76,2.089,2.841,2.841,0,0,1-.783-.11,2.874,2.874,0,1,1,3.542-1.98Z",
    transform: "translate(52.051 -24.456)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M368.188,213.479a7.05,7.05,0,0,0-.879-3l.87-.486a8.068,8.068,0,0,0-1.681-2.1l-.663.745a7.014,7.014,0,0,0-2.741-1.507l.272-.955-.012,0a8,8,0,0,0-2.189-.306c-.157,0-.315.005-.471.014l.059.995a7.047,7.047,0,0,0-3,.876l-.484-.87a8.068,8.068,0,0,0-2.1,1.679l.745.664a7.02,7.02,0,0,0-1.509,2.74l-.954-.273,0,.019a8,8,0,0,0-.306,2.189c0,.156,0,.311.014.464l.995-.059a7.032,7.032,0,0,0,.874,3l-.871.484a8.022,8.022,0,0,0,1.679,2.1l.664-.744a7,7,0,0,0,2.737,1.51l-.273.955.025.008a8.048,8.048,0,0,0,2.189.3c.162,0,.323,0,.484-.015l-.061-.995a7.007,7.007,0,0,0,3-.881l.487.87a8.039,8.039,0,0,0,2.094-1.683l-.746-.663a7.012,7.012,0,0,0,1.505-2.741l.954.271,0-.006a8.048,8.048,0,0,0,.3-2.189c0-.16,0-.318-.014-.477Zm-8.763,6.581h0l.05-.174Zm5.836-5a4.247,4.247,0,1,1,.162-1.161A4.257,4.257,0,0,1,365.261,215.058Z",
    transform: "translate(23.809 -20.959)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.262
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M232.641,121.423a5.4,5.4,0,1,1-5.4-5.4A5.4,5.4,0,0,1,232.641,121.423Z",
    transform: "translate(-8.772 -43.255)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M323.119,61.1a3.374,3.374,0,1,1-3.375-3.375A3.375,3.375,0,0,1,323.119,61.1Z",
    transform: "translate(14.685 -57.722)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M415.545,127.468a3.374,3.374,0,1,1-3.374-3.375A3.373,3.373,0,0,1,415.545,127.468Z",
    transform: "translate(37.62 -41.252)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M428.545,189.134a3.374,3.374,0,1,1-3.374-3.374A3.375,3.375,0,0,1,428.545,189.134Z",
    transform: "translate(40.846 -25.95)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 3.374,
    cy: 3.374,
    r: 3.374,
    transform: "translate(309.897 74.802)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M198.044,71.91a3.374,3.374,0,1,1-3.374-3.374A3.373,3.373,0,0,1,198.044,71.91Z",
    transform: "translate(-16.352 -55.039)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M97,152.4a3.374,3.374,0,1,1-3.375-3.374A3.375,3.375,0,0,1,97,152.4Z",
    transform: "translate(-41.426 -35.064)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(256.261 6.861)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y2: 6.523,
    transform: "translate(3.262)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 6.523,
    transform: "translate(0 3.262)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(61.859 198.114)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y2: 6.523,
    transform: "translate(3.262)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 6.523,
    transform: "translate(0 3.262)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(170.765 67.213)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y2: 6.523,
    transform: "translate(3.262)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x1: 6.523,
    transform: "translate(0 3.262)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(96.5 140.229)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    y2: 6.523,
    transform: "translate(3.262 0)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x1: 6.523,
    transform: "translate(0 3.262)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(24.654 73.378)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y2: 6.523,
    transform: "translate(3.262)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x1: 6.523,
    transform: "translate(0 3.262)",
    fill: "none",
    stroke: "#99a6d6",
    strokeMiterlimit: 10,
    strokeWidth: 0.541
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Page);
export default __webpack_public_path__ + "static/media/404page.d08758c41a0edbdc3d9d4564e6615ac5.svg";
export { ForwardRef as ReactComponent };